module.exports = __webpack_public_path__ + "img/moveonhold.086166af.svg";